<template>
  <aside class="sidebar">
    <div class="logo"><a href="/" class="logo-link">{{ productName }}</a></div>
    <nav>
      <ul>
        <!-- 用户管理 (带子菜单) -->
        <li class="menu-item" :class="{ 'has-submenu': true, 'active': activeMenu === 'user' }">
          <div class="menu-title" @click="toggleMenu('user')">
            <span>{{ $t('nav.userManagement') }}</span>
            <i class="arrow" :class="{ 'down': isMenuOpen('user') }"></i>
          </div>
          <transition name="slide">
            <ul class="submenu" v-show="isMenuOpen('user')">
              <li><router-link to="/user-mgmt">{{ $t('nav.userConfig') }}</router-link></li>
            </ul>
          </transition>
        </li>

        <!-- 文件管理 (带子菜单) -->
        <li class="menu-item" v-if="isModuleEnabled('filemgmt')" :class="{ 'has-submenu': true, 'active': activeMenu === 'file' }">
          <div class="menu-title" @click="toggleMenu('file')">
            <span>{{ $t('nav.fileManagement') }}</span>
            <i class="arrow" :class="{ 'down': isMenuOpen('file') }"></i>
          </div>
          <transition name="slide">
            <ul class="submenu" v-show="isMenuOpen('file')">
              <li  v-if="loadCompo?.includes('admin')" ><router-link to="/file-setting">{{ $t('nav.fileConfig') }}</router-link></li>
              <li><router-link to="/file-list">{{ $t('nav.fileList') }}</router-link></li>
              <li><router-link to="/collect-list">{{ $t('nav.favorites') }}</router-link></li>
              <li><router-link to="/shareLink-list">{{ $t('nav.shareFolder') }}</router-link></li>
              <li  v-if="loadCompo?.includes('admin')" ><router-link to="/network-file-services">{{ $t('nav.networkFileService') }}</router-link></li>
            </ul>
          </transition>
        </li>

        <li class="menu-item" v-if="loadCompo?.includes('filemgmt') && loadCompo?.includes('admin') && isModuleEnabled('fileSync')" >
          <router-link to="/file-sync-mgmt">{{ $t('nav.fileSync') }}</router-link>
        </li>

        <!-- 服务器管理：依赖 serverManagement 模块启用 -->
        <li class="menu-item" v-if="isServerManagementEnabled && loadCompo?.includes('admin')" :class="{ 'has-submenu': true, 'active': activeMenu === 'server' }">
          <div class="menu-title" @click="toggleMenu('server')">
            <span>{{ $t('nav.serverManagement') }}</span>
            <i class="arrow" :class="{ 'down': isMenuOpen('server') }"></i>
          </div>
          <transition name="slide">
            <ul class="submenu" v-show="isMenuOpen('server')">
              <li><router-link to="/transfer-server">{{ $t('nav.transferServer') }}</router-link></li>
              <li><router-link to="/distribution-server">{{ $t('nav.distributionServer') }}</router-link></li>
              <li><router-link to="/official-client">{{ $t('nav.officialClient') }}</router-link></li>
            </ul>
          </transition>
        </li>

        <li class="menu-item"  v-if="loadCompo?.includes('filemgmt') && loadCompo?.includes('admin') && isModuleEnabled('mapping')" >
          <router-link to="/server-mapping">{{ $t('nav.serverMapping') }}</router-link>
        </li>

        <li class="menu-item" v-if="loadCompo?.includes('filemgmt') && loadCompo?.includes('admin') && isModuleEnabled('p2p')" :class="{ 'has-submenu': true, 'active': activeMenu === 'p2p' }">
          <div class="menu-title" @click="toggleMenu('p2p')">
            <span>{{ $t('nav.p2pManagement') }}</span>
            <i class="arrow" :class="{ 'down': isMenuOpen('p2p') }"></i>
          </div>
          <transition name="slide">
            <ul class="submenu" v-show="isMenuOpen('p2p')">
              <li v-if="loadCompo?.includes('filemgmt')  && loadCompo?.includes('admin')"><router-link to="/p2p-setting">{{ $t('nav.p2pSetting') }}</router-link></li>
              <li v-if="loadCompo?.includes('filemgmt')  && loadCompo?.includes('admin')"><router-link to="/p2p-client">{{ $t('nav.p2pClient') }}</router-link></li>
            </ul>
          </transition>
        </li>

        <li class="menu-item" v-if="loadCompo?.includes('filemgmt') && loadCompo?.includes('admin') && isModuleEnabled('proxy')" :class="{ 'has-submenu': true, 'active': activeMenu === 'proxy' }">
          <div class="menu-title" @click="toggleMenu('proxy')">
            <span>{{ $t('nav.proxyManagement') }}</span>
            <i class="arrow" :class="{ 'down': isMenuOpen('proxy') }"></i>
          </div>
          <transition name="slide">
            <ul class="submenu" v-show="isMenuOpen('proxy')">
              <li v-if="loadCompo?.includes('filemgmt')  && loadCompo?.includes('admin')"><router-link to="/proxy-mgmt">{{ $t('nav.forwardProxy') }}</router-link></li>
              <li v-if="loadCompo?.includes('filemgmt')  && loadCompo?.includes('admin')"><router-link to="/reverse-proxy">{{ $t('nav.reverseProxy') }}</router-link></li>
            </ul>
          </transition>
        </li>


        <li class="menu-item" v-if="loadCompo?.includes('filemgmt') && loadCompo?.includes('admin') && isModuleEnabled('dns')" :class="{ 'has-submenu': true, 'active': activeMenu === 'ddns' }">
          <div class="menu-title" @click="toggleMenu('ddns')">
            <span>{{ $t('nav.ddnsManagement') }}</span>
            <i class="arrow" :class="{ 'down': isMenuOpen('ddns') }"></i>
          </div>
          <transition name="slide">
            <ul class="submenu" v-show="isMenuOpen('ddns')">
              <li v-if="loadCompo?.includes('filemgmt')  && loadCompo?.includes('admin')" ><router-link to="/ddns-setting">{{ $t('nav.ddnsSetting') }}</router-link></li>
              <li v-if="loadCompo?.includes('filemgmt')  && loadCompo?.includes('admin')" ><router-link to="/aliyun-ddns">{{ $t('nav.aliyunDdns') }}</router-link></li>
              <li v-if="loadCompo?.includes('filemgmt')  && loadCompo?.includes('admin')" ><router-link to="/tencentcloud-ddns">{{ $t('nav.tencentcloudDdns') }}</router-link></li>
              <li v-if="loadCompo?.includes('filemgmt')  && loadCompo?.includes('admin')" ><router-link to="/pubyun-ddns">{{ $t('nav.pubyunDdns') }}</router-link></li>
              <li v-if="loadCompo?.includes('filemgmt')  && loadCompo?.includes('admin')" ><router-link to="/nameyun-ddns">{{ $t('nav.namecomDdns') }}</router-link></li>
              <li v-if="loadCompo?.includes('filemgmt')  && loadCompo?.includes('admin')" ><router-link to="/cloudflare-ddns">{{ $t('nav.cloudflareDdns') }}</router-link></li>
            </ul>
          </transition>
        </li>

        <!-- 其他单层菜单项 -->
        <li class="menu-item" v-if="loadCompo?.includes('filemgmt') && loadCompo?.includes('admin') && isModuleEnabled('acme')" >
          <router-link to="/acme-mgmt">{{ $t('nav.acmeManagement') }}</router-link>
        </li>

        <li class="menu-item" v-if="loadCompo?.includes('filemgmt') && loadCompo?.includes('admin') && !loadCompo?.includes('darwin') && isModuleEnabled('mountManagement')" >
          <router-link to="/mount-mgmt">{{ $t('nav.mountSettings') }}</router-link>
        </li>

        <li class="menu-item"  v-if="loadCompo?.includes('filemgmt')  && loadCompo?.includes('admin') && isModuleEnabled('deviceCenter')" >
          <router-link to="/device-center">{{ $t('nav.deviceCenter') }}</router-link>
        </li>

        <li class="menu-item"  v-if="loadCompo?.includes('filemgmt')  && loadCompo?.includes('admin')" >
          <router-link to="/module-mgmt">{{ $t('nav.moduleManagement') }}</router-link>
        </li>

        <li class="menu-item"  v-if="loadCompo?.includes('filemgmt')  && loadCompo?.includes('admin')" >
          <router-link to="/sys-setting">{{ $t('nav.systemSettings') }}</router-link>
        </li>

        <li class="menu-item">
          <router-link to="/sys-about">{{ $t('nav.about') }}</router-link>
        </li>

<!--
        <li class="menu-item" v-if="loadCompo?.includes('oldweb')" >
            <a href="#" @click.prevent="goToLegacyHome" class="old-page-link">{{ $t('nav.legacyEntry') }}</a>
        </li>
-->
      </ul>
    </nav>
    <div class="logout" @click="handleLogout">
      <span v-if="isLoggedIn">{{ $t('nav.logout', { username }) }}</span>
      <span v-else>{{ $t('nav.loggedOut') }}</span>
    </div>
    <div class="lang-switcher">
      <el-dropdown @command="handleLangCommand" trigger="click">
        <span class="lang-trigger">
          <el-icon><Globe /></el-icon>
          {{ langLabel }}
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="zh-cn" :disabled="locale === 'zh-cn'">简体中文</el-dropdown-item>
            <el-dropdown-item command="en" :disabled="locale === 'en'">English</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </aside>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useLangStore } from '@/stores/lang'
import { Globe } from '@element-plus/icons-vue'
import { ElDropdown, ElDropdownMenu, ElDropdownItem, ElIcon } from 'element-plus'
import eventBus from '@/utils/eventBus'; // 导入事件总线
import { API_BASE_URL } from "@/config";
import { HOME_BASE_URL } from "@/config";

export default {
  name: 'AppSidebar',
  components: {
    ElDropdown,
    ElDropdownMenu,
    ElDropdownItem,
    ElIcon,
    Globe
  },
  setup() {
    const { locale } = useI18n()
    const langStore = useLangStore()
    const router = useRouter()
    const activeMenu = ref('')
    const openMenus = ref([])
    const isLoggedIn = ref(false)
    const username = ref('')
    const productName = ref('tfcenter')
    const loadCompo = ref('')
    const moduleStatus = ref({})  // 模块启用状态

    // 获取模块状态
    const fetchModuleStatus = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/modules`, {
          credentials: 'include'
        })
        const result = await response.json()
        if (result.code === 0 && result.data) {
          const status = {}
          result.data.forEach(mod => {
            status[mod.name] = mod.enabled
          })
          moduleStatus.value = status
        }
      } catch (error) {
        console.error('获取模块状态失败:', error)
      }
    }

    // 检查登录状态
    const checkLoginStatus = () => {
      // 这里可以根据实际情况从localStorage、cookie或vuex中获取登录状态
      const userInfo = localStorage.getItem('userInfo')
      if (userInfo) {
        try {
          const user = JSON.parse(userInfo)
          isLoggedIn.value = true
          username.value = user.username || 'none'
          loadCompo.value = user.loadCompo || ''
          productName.value = user.productName || 'tfcenter'
        } catch (e) {
          console.error('解析用户信息失败', e)
          isLoggedIn.value = false
        }
      } else {
        isLoggedIn.value = false
      }
    }

    // 检查模块是否启用
    const isModuleEnabled = (name) => {
      return moduleStatus.value[name] === true
    }

    // 服务器管理：依赖 serverManagement 配置
    const isServerManagementEnabled = computed(() => {
      return moduleStatus.value['serverManagement'] === true
    })

    // 登出处理
    const handleLogout = () => {
      if (isLoggedIn.value) {
        fetch(`${API_BASE_URL}/logout`, {
          method: 'POST',
          credentials: 'include', // 允许携带 Cookie（如 JWT）
        });

        // 清除用户信息
        localStorage.removeItem('userInfo')
        // 更新状态
        isLoggedIn.value = false
        username.value = ''
        
        // 跳转到登录页
        router.push('/user-login?auto=n')
      } else {
        // 未登录状态下点击，跳转到登录页
        router.push('/user-login?auto=n')
      }
    }

    const isMenuOpen = (menu) => {
      return openMenus.value.includes(menu)
    }

    const toggleMenu = (menu) => {
      if (isMenuOpen(menu)) {
        openMenus.value = openMenus.value.filter(m => m !== menu)
      } else {
        openMenus.value.push(menu)
      }
      activeMenu.value = menu
    }

    // 语言切换
    const langLabel = computed(() => locale.value === 'zh-cn' ? '中文' : 'EN')

    const handleLangCommand = (cmd) => {
      locale.value = cmd
      langStore.setLocale(cmd)
    }

    // 组件挂载时检查登录状态
    onMounted(() => {
      checkLoginStatus()
      fetchModuleStatus()

      // 监听登录事件
      eventBus.on('login', (user) => {
        if (user.username == undefined || user.username == '') {
          isLoggedIn.value = false
        } else {
          isLoggedIn.value = loadCompo
        }
        username.value = user.username;
        loadCompo.value = user.loadCompo
        // 登录后刷新模块状态
        fetchModuleStatus()
      });

      // 监听模块状态变化事件
      eventBus.on('module-changed', () => {
        // 刷新模块状态
        fetchModuleStatus()
      });
    })

    return {
      activeMenu,
      isMenuOpen,
      toggleMenu,
      isLoggedIn,
      username,
      productName,
      loadCompo,
      moduleStatus,
      isModuleEnabled,
      isServerManagementEnabled,
      handleLogout,
      langLabel,
      handleLangCommand,
      locale
    }
  },
  methods: {
    goToLegacyHome() {
      window.location.href = HOME_BASE_URL + '/home';
    }
  }
}


</script>

<style scoped>
.sidebar {
  position: fixed; /* 固定定位 */
  top: 0;
  left: 0;
  width: 220px;
  height: 100vh; /* 高度占满整个视口 */
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  z-index: 1000; /* 确保导航栏在最上层 */
  overflow-y: auto; /* 如果内容过长，允许导航栏自身滚动 */
}

.logo {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  margin: 0 15px 30px;
}

.logo-link {
  text-decoration: none;   /* 移除下划线 */
  color: #FFFFFF;         /* 使用Element UI的主色调蓝色 */
  font-weight: 600;       /* 中等加粗 */
  font-size: 1.2rem;      /* 稍大的字号 */
  letter-spacing: 1px;    /* 字间距微调 */
  transition: color 0.3s; /* 颜色过渡动画 */
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif; /* 中文字体优化 */
}

.logo-link:hover {
  color: #337ecc;         /* 悬停时加深蓝色 */
  text-decoration: none;  /* 确保悬停时也无下划线 */
}

.old-page-link {
  text-decoration: none;   /* 移除下划线 */
  color: #FFFFFF;         /* 使用Element UI的主色调蓝色 */
  font-size: 1rem;      /* 稍大的字号 */
  letter-spacing: 1px;    /* 字间距微调 */
  transition: color 0.3s; /* 颜色过渡动画 */
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif; /* 中文字体优化 */
}

.old-page-link:hover {
  color: #337ecc;         /* 悬停时加深蓝色 */
  text-decoration: none;  /* 确保悬停时也无下划线 */
}

nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-item {
  position: relative;
}

.menu-item a, .menu-title {
  color: #ecf0f1;
  text-decoration: none;
  display: block;
  padding: 12px 20px;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.menu-item a:hover, .menu-title:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.menu-item a.router-link-exact-active {
  background-color: #3498db;
  color: white;
}

.has-submenu.active > .menu-title {
  background-color: rgba(255, 255, 255, 0.1);
}

.submenu {
  background-color: rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.submenu a {
  padding-left: 40px;
  font-size: 14px;
}

.arrow {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #ecf0f1;
  transition: transform 0.3s;
}

.arrow.down {
  transform: rotate(180deg);
}

.slide-enter-active, .slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter-from, .slide-leave-to {
  max-height: 0;
  opacity: 0;
}

.slide-enter-to, .slide-leave-from {
  max-height: 200px;
  opacity: 1;
}

.logout {
  margin-top: auto;
  padding: 15px 20px 25px;
  cursor: pointer;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
}

.logout:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.lang-switcher {
  padding: 12px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.lang-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  color: #ecf0f1;
  font-size: 14px;
}

.lang-trigger:hover {
  color: #fff;
}
</style>